import React, { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "../components/Layout";
import { verifyPayment } from "../redux/actions/cart";
import { sendCoordinates, verifyGiftTribute } from "../redux/actions/profile";

const PaymentVerify = () => {
  const PLACED_GIFTS_KEY = "ar_placed_gifts";
  const { session_id } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const medallion_id = searchParams.get("medallion_id");
  const giftCords = localStorage?.getItem(PLACED_GIFTS_KEY)
    ? JSON.parse(localStorage.getItem(PLACED_GIFTS_KEY))
    : null;

  useEffect(() => {
    const handleVerifyPayment = async () => {
      try {
        if (medallion_id) {
          const payload = { session_id };
          await dispatch(verifyGiftTribute(payload)).unwrap();
          if (giftCords) {
            const payload2 = { medallion_id, codes: giftCords };
            const response = await dispatch(sendCoordinates(payload2)).unwrap();
            if (response.status == 200) {
              localStorage.removeItem(PLACED_GIFTS_KEY);
              navigate(`/profile/${medallion_id}?tab=Tribute`);
            }
          } else {
            navigate(`/profile/${medallion_id}?tab=Tribute`);
          }
        } else {
          const payload = { session_id };
          await dispatch(verifyPayment(payload)).unwrap();
          navigate("/view-memories");
        }
      } catch (error) {
        console.error("Payment verification error:", error);
      }
    };

    if (session_id) {
      handleVerifyPayment();
    }
  }, [session_id, medallion_id, dispatch, navigate]);

  return (
    <Layout>
      <div style={{ padding: "100px 20px", textAlign: "center" }}>
        <h2>Authenticated</h2>
      </div>
    </Layout>
  );
};

export default PaymentVerify;
